"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _toConsumableArray = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/toConsumableArray");

var _objectWithoutProperties = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/objectWithoutProperties");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.filter");

var _defineProperty = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/defineProperty");

require("core-js/modules/es6.array.map");

var _slicedToArray = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.object.define-property");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStack = useStack;
exports.STATES = void 0;

var _react = require("react");

var _dateFns = require("date-fns");

var STATES = {
  LOADING: 'loading',
  DELETING: 'deleting',
  READY: 'ready'
};
exports.STATES = STATES;

function useStack() {
  var _ref = (0, _react.useState)([]),
      _ref2 = _slicedToArray(_ref, 2),
      stack = _ref2[0],
      updateStack = _ref2[1];

  var incrementalId = (0, _react.useRef)(0);
  var closeCallbacksEventBus = (0, _react.useRef)([]);
  var removeRef = (0, _react.useRef)();

  var update = function update(id, newOptions) {
    updateStack(function (newStack) {
      return newStack.map(function (item) {
        return item.id === id ? _objectSpread({}, item, {}, newOptions, {
          id: id
        }) : item;
      });
    });
  };

  var remove = function remove(id) {
    updateStack(function (newStack) {
      return newStack.filter(function (item) {
        if (item.id !== id) {
          return true;
        }

        if (item.onClose) {
          closeCallbacksEventBus.current.push(item.onClose);
        }

        return false;
      });
    });
  };

  var flagToRemove = function flagToRemove(id) {
    var toast = stack.find(function (t) {
      return t.id === id;
    });

    if (!toast || toast.removing) {
      return;
    }

    update(id, {
      state: STATES.DELETING
    });
    setTimeout(function () {
      return remove(id);
    }, 1000);
  };

  removeRef.current = flagToRemove; // This use effect executes all close callback after the component update
  // ---- (close action) ----
  //                     ---- (component life cycle) ----
  //                                                 ---- (close callback) ----

  (0, _react.useEffect)(function () {
    closeCallbacksEventBus.current = closeCallbacksEventBus.current.filter(function (callback) {
      callback();
      return false;
    });
    return function () {
      stack.forEach(function (toast) {
        clearTimeout(toast.timeout);
      });
    };
  });
  return {
    stack: stack,
    push: function push(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _options$level = options.level,
          level = _options$level === void 0 ? 'info' : _options$level,
          _options$delay = options.delay,
          delay = _options$delay === void 0 ? 5000 : _options$delay,
          rest = _objectWithoutProperties(options, ["level", "delay"]);

      var id = ++incrementalId.current;
      updateStack(function (newStack) {
        return [].concat(_toConsumableArray(newStack), [_objectSpread({
          id: id,
          level: level,
          message: message,
          delay: delay,
          state: delay > 0 ? STATES.LOADING : STATES.READY
        }, rest, {
          timeLeft: delay,
          startedAt: new Date(),
          timeout: delay > 0 ? setTimeout(function () {
            return removeRef.current(id);
          }, delay) : null
        })]);
      });
    },
    update: update,
    remove: flagToRemove,
    pause: function pause(id) {
      var toast = stack.find(function (t) {
        return t.id === id;
      });

      if (toast.delay === -1) {
        return;
      }

      update(id, {
        state: toast.state === STATES.DELETING ? toast.state : STATES.READY,
        timeLeft: toast.timeLeft - (0, _dateFns.differenceInMilliseconds)(new Date(), toast.startedAt)
      });
      clearTimeout(toast.timeout);
    },
    resume: function resume(id) {
      var toast = stack.find(function (t) {
        return t.id === id;
      });
      var newState = toast.state;

      if (toast.delay === -1) {
        return;
      }

      if (toast.state !== STATES.DELETING) {
        newState = toast.timeLeft > 0 ? STATES.LOADING : STATES.READY;
      }

      update(id, {
        startedAt: new Date(),
        timeout: setTimeout(function () {
          removeRef.current(id);
        }, toast.timeLeft),
        state: newState
      });
    }
  };
}